import { useEffect, useMemo, useState } from "react";
import TeacherPhoto from "./TeacherPhoto";

const PREVIEW_COUNT = 3;

function MainOfferings(props) {
  const teacherArray = useMemo(() => {
    return Array.isArray(props.teachers) ? props.teachers : [];
  }, [props.teachers]);

  const [teachers, setTeachers] = useState([]);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    setTeachers(teacherArray.slice(0, PREVIEW_COUNT));
    setExpanded(false);
  }, [teacherArray]);

  const toggleTeachers = () => {
    if (expanded) {
      setTeachers(teacherArray.slice(0, PREVIEW_COUNT));
      setExpanded(false);
    } else {
      setTeachers(teacherArray);
      setExpanded(true);
    }
  };

  if (!teachers.length) return null;

  return (
    <section className="student-section student-offerings" aria-label="Offerings">
      <div className="student-section__inner">
        <header className="student-section__header">
          <p className="student-section__eyebrow">Faculty</p>
          <h2 className="student-section__title">Our offerings</h2>
          <p className="student-section__lede">
            Expert educators guiding students toward clarity and confidence.
          </p>
        </header>

        <div className="student-offerings__grid">
          {teachers.map((teacher) => (
            <article
              className="student-offerings__card"
              key={teacher.teacherId || teacher.id || teacher.name}
            >
              <TeacherPhoto
                picture={teacher.picture}
                name={teacher.name}
                className="student-offerings__photo"
                variant="portrait"
              />
              <div className="student-offerings__body">
                {teacher.caption && (
                  <p className="student-offerings__caption">{teacher.caption}</p>
                )}
                <h3 className="student-offerings__name">{teacher.name}</h3>
                {teacher.description && (
                  <p className="student-offerings__desc">
                    {teacher.description}
                  </p>
                )}
              </div>
            </article>
          ))}
        </div>

        {teacherArray.length > PREVIEW_COUNT && (
          <button
            type="button"
            className="student-offerings__toggle"
            onClick={toggleTeachers}
          >
            {expanded ? "View Less" : "View More"}
          </button>
        )}
      </div>
    </section>
  );
}

export default MainOfferings;
